import { supabase } from './supabaseClient';

export async function callAuthenticatedFunction(
  functionName,
  payload,
  fallbackMessage
) {
  const {
    data: { session },
    error: sessionError,
  } = await supabase.auth.getSession();

  if (sessionError) throw sessionError;
  if (!session?.access_token) {
    throw new Error('Your login session has expired. Please log in again.');
  }

  const response = await fetch(`/.netlify/functions/${functionName}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${session.access_token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  let result;
  try {
    result = await response.json();
  } catch {
    throw new Error('The user-management service returned an invalid response.');
  }

  if (!response.ok) {
    throw new Error(result?.error || fallbackMessage);
  }

  return result;
}
